<rt-attachment-item
  *ngIf="attachmentLike && !hasOnlyButton"
  [attachment]="attachmentLike"
  [onlyImage]="!attachmentLike.filename"
  [hasShadow]="hasShadow"
  [hasDownloadAction]="downloadable"
  [hasSetAsCvAction]="canManageCandidates"
  (deleteClick)="clearValue()"
  margin-bottom-small
  small
  deletable
>
</rt-attachment-item>

<div layout-horizontal>
  <input
    #fileInput
    [accept]="accept"
    (change)="onFileChange(fileInput.files)"
    (blur)="blur.emit()"
    type="file"
    hidden
  />
  <rt-button
    *ngIf="!buttonPrimary"
    [loading]="loadingButton"
    (click)="fileInput.click()"
    variant="simple"
  >
    <rt-icon *ngIf="withIcon" name="file-upload"></rt-icon>
    {{ buttonText }}
  </rt-button>
  <rt-button
    *ngIf="buttonPrimary"
    [loading]="loadingButton"
    [paddingSmall]="buttonPaddingSmall"
    (click)="fileInput.click()"
    variant="primary"
  >
    <rt-icon name="file-upload" *ngIf="withIcon"></rt-icon>
    {{ buttonText }}
  </rt-button>
</div>
